import { render, staticRenderFns } from "./carrito.vue?vue&type=template&id=e8fa54a2"
import script from "./carrito.vue?vue&type=script&lang=js"
export * from "./carrito.vue?vue&type=script&lang=js"
import style0 from "./carrito.vue?vue&type=style&index=0&id=e8fa54a2&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports